import {
  Component,
  OnInit,
  TemplateRef,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { AppService } from "../services/app.service";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { MyDatePicker, IMyDpOptions } from "mydatepicker";
import { mobiscroll, MbscDatetimeOptions } from '@mobiscroll/angular';
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";
import { DatePipe } from "@angular/common";
import { Router, ActivatedRoute } from "@angular/router";
import { environment } from "src/environments/environment";

interface selectProcedre {
  examId: "";
  bodyPartList: any[];
  bodyPartId: "";
  procedureList: any[];
  cptCode: "";
  procedureName: "";
  open: boolean;
  examName?: "";
  bodyPartName?: "";
  selectedProcedure?: "";
  duration: "";
  procedureID?: "";
  invalidcptcode: boolean;
  tmpcptcode: "";
}

const days: any = [
  { id: 1, name: "monDay", value: "Monday", key: "Mon" },
  { id: 2, name: "tueDay", value: "Tuesday", key: "Tue" },
  { id: 3, name: "wedDay", value: "Wednesday", key: "Wed" },
  { id: 4, name: "thuDay", value: "Thursday", key: "Thu" },
  { id: 5, name: "friDay", value: "Friday", key: "Fri" },
  { id: 6, name: "satDay", value: "Saturday", key: "Sat" },
  { id: 0, name: "sunDay", value: "Sunday", key: "Sun" },
];

@Component({
  selector: "app-schedule-appointment",
  templateUrl: "./schedule-appointment.component.html",
  styleUrls: ["./schedule-appointment.component.scss"],
})
export class ScheduleAppointmentComponent implements OnInit {
  @ViewChild("scrollMe") private myScrollContainer: ElementRef;
  @ViewChild("mydp") mydp: MyDatePicker;

  examList: any = [];
  countryId: any = 231;
  countryCode: any = "IN";
  testCountryCode: any = "US";
  insuranceList: any = [];
  selectedIns: any = [
    { insId: "", insType: "", insTmpId: "", insExists: false, insName: "" },
  ];
  modalRef: BsModalRef;
  config = {
    ignoreBackdropClick: true,
    keyboard: false,
  };

  selectProcedureList: selectProcedre[] = [];
  public myDatePickerOptions: IMyDpOptions = {};
  @ViewChild("anotherProcedureNew") anotherProcedureNew: TemplateRef<any>;
  @ViewChild("yesornoPopup") yesornoPopup: TemplateRef<any>;
  today: any = new Date();
  currentDate: number;
  currentMonth: number;
  currentYear: number;
  homeDate: any = this.formatHomeDate(this.today);
  homeDatePlaceHolder: any = this.formatHomeDate(this.today);
  homeinfosubmit = false;
  homeLocation: any = "";
  currentLocation: any = "";
  homeLocationPlaceholder: any = "Location";
  homeInsurance: any = "";
  homeInsuranceName: any = "";
  homeInsuranceNameNew: any = "";
  homeInsuranceTypeName: any = "";
  homeInsuranceType: any = 2;
  homeExamName: any = "";
  homeBodyPartName: any = "";
  popoverValidationMsg: any = "Please select exam and body part";
  multiplePro = false;
  placeholerCptCode: any = "Procedure Name";
  selectedcptCodeListAmount = [];
  // tslint:disable-next-line:member-ordering
  showErrDate = false;
  // tslint:disable-next-line:member-ordering
  lat: number;
  lng: number;
  allExamList: any = [];
  selectIndex: any = -1;
  popProcedures: any = [];
  testCenterId = "";
  dayOfweek = "";
  timezone_offset_min: any;
  offset_hrs: any;
  offset_min: any;
  paymode: any;
  cptCodeList: any = [];
  scheduleappointmentid: any = "";
  isSelf = false;
  scheduleList: any = [];
  scheduleDate = new Date();
  selectedSchedule;
  selfAmount = "";
  errors: any = [];
  scheduleID = "";
  scheduleDetails: any = {};
  scheduleDetail: any = {};
  selectedcptCodeList: any = [];
  isWaiting = false;
  workingHours: any = [];
  isCurrentDate = false;
  isDateSelect = false;
  selectedDate: any = {};
  errorMessage = "";
  cptcodeobject: any;
  tcOffset = 0;
  waitingboolean = "";
  homedate = "";
  index = 0;
  popuptype = "";
  popupContent = "";
  popupheading = "";
  dateSettings: MbscDatetimeOptions = {};
  formatter: any;
  constructor(
    private appService: AppService,
    private toastr: ToastrService,
    private datePipe: DatePipe,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: BsModalService
  ) {
    this.today.setHours(0, 0, 0, 0);
    this.currentDate = this.today.getDate() - 1;
    this.currentMonth = this.today.getMonth() + 1;
    this.currentYear = this.today.getFullYear();
    this.dateSettings = {
      dateFormat: 'M dd, yyyy',
      display: 'center',
      min: this.today
    };
}

  ngOnInit() {
    this.waitingboolean = sessionStorage.getItem("waitingid")
      ? sessionStorage.getItem("waitingid")
      : "";
    this.viewTestCenter();
    this.getAllexam();
    this.addDefaultProcedure();
    // this.getScheduleList();

    this.formatter = new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
    });
  }

  addDefaultProcedure() {
    const procedure: selectProcedre = {
      examId: "",
      bodyPartList: [],
      bodyPartId: "",
      procedureList: [],
      cptCode: "",
      procedureName: "",
      open: false,
      examName: "",
      bodyPartName: "",
      selectedProcedure: "",
      duration: "",
      invalidcptcode: false,
      tmpcptcode: "",
    };

    this.selectProcedureList.push(procedure);
  }

  getRoundedDate = (minutes, d = new Date()) => {
    const ms = 1000 * 60 * minutes; // convert minutes to ms
    return new Date(Math.round(d.getTime() / ms) * ms);
  };

  getScheduleList() {
    const params: any = {};
    const now = new Date();
    const zoneDate = new Date(now.getTime() + now.getTimezoneOffset() * 60000);
    zoneDate.setMinutes(zoneDate.getMinutes() + this.tcOffset + 15);

    if (this.selectedcptCodeList.length > 0) {
      params.cptCodes = [];
      this.selectedcptCodeList.forEach((val) => {
        params.cptCodes.push(val);
      });
    }

    const roundedDate = this.getRoundedDate(15, zoneDate);
    roundedDate.setSeconds(0);
    params.currentTime = this.datePipe.transform(roundedDate, "hh:mm aa");

    params.currentDate = this.datePipe.transform(roundedDate, "yyyy-MM-dd");
    params.scheduleOn = this.datePipe.transform(
      this.scheduleDate,
      "yyyy-MM-dd"
    );
    params.timeZone = "";

    this.appService.gettcscheduleList(params).subscribe((schedule: any) => {
      if (schedule.status) {
        if (schedule.status.status === 200) {
          this.scheduleList = [];
          this.scheduleList.push({
            dateStr: moment(this.scheduleDate, "DD-MM-YYYY")
              .add(-1, "days")
              .format("YYYY-MM-DD"),
          });
          this.scheduleList.push({ dateStr: params.scheduleOn });
          this.scheduleList.push({
            dateStr: moment(this.scheduleDate, "DD-MM-YYYY")
              .add(+1, "days")
              .format("YYYY-MM-DD"),
          });
          if (schedule.entity.schedules.length > 0) {
            this.scheduleList.forEach((slot, index) => {
              schedule.entity.schedules.forEach((slot1) => {
                if (slot.dateStr === slot1.dateStr) {
                  slot = slot1;
                  this.scheduleList[index] = slot1;
                }
              });
            });
          }
          if (this.scheduleList.length > 0) {
            this.isCurrentDate = false;
            this.scheduleList.forEach((scheduleData, index) => {
              const date = moment(new Date(), "YYYY-MM-DD");
              scheduleData.currentDate = false;
              if (scheduleData.dateStr === date.format("YYYY-MM-DD")) {
                scheduleData.currentDate = true;
                if (index === 1) {
                  this.isCurrentDate = true;
                }
              }
              if (this.selectedSchedule) {
                if (this.selectedSchedule.date === scheduleData.dateStr) {
                  if (scheduleData.schedules) {
                    if (scheduleData.schedules.length > 0) {
                      scheduleData.schedules[
                        this.selectedSchedule.index
                      ] = this.selectedSchedule;
                    }
                  }
                }
              }
              if (this.scheduleDetail.payMode === "self") {
                this.selfAmount = this.scheduleDetail.totalAmount;
                this.selfChange(this.isSelf);
              }
              if (this.scheduleDetail) {
                if (
                  this.scheduleDetail.scheduledOnStr === scheduleData.dateStr
                ) {
                  if (
                    scheduleData &&
                    scheduleData.schedules &&
                    scheduleData.schedules.length > 0
                  ) {
                    scheduleData.schedules.forEach((timeline, index) => {
                      timeline.select = false;
                      if (
                        this.scheduleDetail.scheduleFromTime ===
                          timeline.procedureInputs[0].fromTime &&
                        this.scheduleDetail.scheduleToTime ===
                          timeline.procedureInputs[0].toTime
                      ) {
                        timeline.select = true;
                        timeline.date = scheduleData.dateStr;
                        timeline.index = index;
                        this.selectedSchedule = timeline;
                      }
                    });
                  }
                }
              }
            });
          }
          const date = new Date(this.scheduleDate);
          this.selectedDate = {
            date: {
              year: date.getFullYear(),
              month: date.getMonth() + 1,
              day: date.getDate(),
            },
          };
          this.isDateSelect = true;
        } else if (schedule.status.status === 239) {
          this.errorMessage = "Please add credit card";
          setTimeout(() => {
            this.errorMessage = "";
          }, 5000);
        } else if (schedule.status.status === 246) {
          this.errorMessage = "Please activate your subscription";
          setTimeout(() => {
            this.errorMessage = "";
          }, 5000);
        }
      }
    });
  }

  onChangedCptcode(value, index, type) {
    const cptcode = value;
    if (cptcode && cptcode.toString().trim().length === 5) {
      let isExist = false;
      if (this.selectProcedureList && this.selectProcedureList.length > 0) {
        for (let s = 0; s < this.selectProcedureList.length; s++) {
          if (this.selectProcedureList[s].cptCode === cptcode) {
            isExist = true;
            break;
          }
        }
        if (!isExist) {
          this.getallExamListOnchange(cptcode.toString().trim(), index, type);
        } else {
          this.toastr.error("Procedure already selected");
          this.selectProcedureList[index].bodyPartId = "";
          this.selectProcedureList[index].cptCode = "";
          this.selectProcedureList[index].bodyPartName = "";
          this.selectProcedureList[index].procedureName = "";
          this.selectProcedureList[index].procedureList = [];
        }
      } else {
        this.getallExamListOnchange(cptcode.toString().trim(), index, type);
      }
    }
  }

  getallExamListOnchange(cptcode, index, type) {
    const data = {
      cptcode: cptcode,
      tcId: localStorage.getItem("testCenterId"),
    };

    this.appService
      .getallexamdandprocedureandbodypartbycptcode(data)
      .subscribe((res) => {
        if (res && res["status"]["status"] === 200) {
          if (
            res &&
            res["entity"] &&
            res["entity"]["examId"] &&
            res["entity"]["bodyPartId"]
          ) {
            this.cptcodeobject = res["entity"];
            this.selectProcedureList[index].examId = res["entity"]["examId"];
            this.selectProcedureList[index].invalidcptcode = false;
            for (let index = 0; index < this.allExamList.length; index++) {
              this.allExamList[index].checked = false;
              for (let i = 0; i < this.selectProcedureList.length; i++) {
                if (
                  this.selectProcedureList[i].examId ===
                  this.allExamList[index].id
                ) {
                  this.allExamList[index].checked = true;
                  this.allExamList[index].examName = this.cptcodeobject[
                    "procedureInfo"
                  ]["bodyPart"]["exam"]["examshortname"];
                  this.selectProcedureList[i].examName = this.cptcodeobject[
                    "procedureInfo"
                  ]["bodyPart"]["exam"]["examshortname"];
                  break;
                }
              }
            }
            this.selectProcedureList[index].cptCode = this.cptcodeobject[
              "cptCode"
            ];
            this.selectProcedureList[index].tmpcptcode = this.cptcodeobject[
              "cptCode"
            ];
            this.getallbodypartsbyexamonchange(
              res["entity"]["examId"],
              index,
              type
            );
          }
        } else if (res["status"]["status"] === 204) {
          this.toastr.error("Please check your cptcode");
          this.selectProcedureList[index].invalidcptcode = true;
          this.selectProcedureList[index].bodyPartId = "";
          this.selectProcedureList[index].bodyPartName = "";
          this.selectProcedureList[index].procedureName = "";
          this.selectProcedureList[index].procedureList = [];
        }
      });
  }
  viewTestCenter() {
    this.appService.viewtestcenter().subscribe(
      (res) => {
        if (
          res &&
          res["status"] &&
          res["status"] &&
          res["status"]["status"] === 200
        ) {
          if (res["entity"]) {
            this.workingHours = res["entity"]["workingHours"];
            localStorage.setItem("testCenterId", res["entity"]["id"]);
            this.testCenterId = localStorage.getItem("testCenterId");
            this.countryId = res["entity"]["address"]["country"]["id"];
            this.homeLocation = res["entity"]["address"]["state"]["state"];
            this.testCountryCode =
              res["entity"]["address"]["country"]["countryCode"];
            if (this.testCountryCode === "US") {
              this.formatter = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 0,
              });
            } else if (this.testCountryCode === "IN") {
              this.formatter = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "INR",
                minimumFractionDigits: 0,
              });
            }

            this.lat = res["entity"]["latitude"];
            this.lng = res["entity"]["longitude"];
            this.getOffsetZone(this.lat,this.lng,this.testCountryCode === "IN"?101:231);
            this.getAllinsurancebycountry();
            if (this.workingHours.length > 0) {
              days.forEach((day) => {
                this.workingHours.forEach((work) => {
                  if (work.workHourType === "work") {
                    if (work[day.name]) {
                      day.work = true;
                      day.fromHour = work.fromHour;
                      day.toHour = work.toHour;
                      day.from24Hour = this.convertTime12to24(work.fromHour);
                      day.to24Hour = this.convertTime12to24(work.fromHour);
                    }
                  }
                });
              });
            }
          }
        }
      },
      (err) => {
        this.appService.sessionOut(err);
      }
    );
  }


  getOffsetZone(latitude, longitude,type) {
    this.appService.getTimeZoneByLatLng(latitude, longitude).subscribe(
      (res) => {
        if (res && res['status'] == 'OK') {
          if(type === 101){
            if(res["rawOffset"] != 0){
              this.tcOffset = +((+res['rawOffset'])/60);
            }
          }else if(res['rawOffset'] != 0) {
            var dstOffset = 0;
            if(res["dstOffset"] != 0){
              dstOffset = +((+res["dstOffset"])/60);
            }

            this.tcOffset = +(+((+res['rawOffset'])/60) + (+dstOffset) + 60);
          } 
        }
        console.log(this.tcOffset);
      },
      (err) => ({})
    );
  }


  getAllexam() {
    this.appService.getAllExamswithProcedure().subscribe((res: any) => {
      if (res.status.status === 200) {
        this.allExamList = res.entity;
        if (this.allExamList.length > 0) {
          this.allExamList.forEach((exam) => {
            exam.checked = false;
          });
          const routeParams = this.route.snapshot.params;
          if (routeParams.patientID) {
            this.scheduleID = routeParams.patientID;
            if (this.scheduleID) {
              this.getScheduledetails();
            }
          } else if (sessionStorage.getItem("waitinglistdata")) {
            this.setWaitingListDetails();
          } else {
            this.setScheduleDetail();
          }
        }
      }
    });
  }

  getScheduledetails() {
    this.appService
      .viewscheduleappointmentpro(this.scheduleID)
      .subscribe((scheduleDetail: any) => {
        if (scheduleDetail.status.status === 200) {
          this.scheduleDetails = scheduleDetail.entity;
          this.scheduleDetail = this.scheduleDetails.schedule;
          if (this.scheduleDetails.procedures) {
            if (this.scheduleDetails.procedures.length > 0) {
              this.selectProcedureList = this.scheduleDetails.selectProcedures;
              this.selectProcedureList.forEach((proceduce, index) => {
                proceduce.duration = this.scheduleDetails.procedures[
                  index
                ].duration;
                proceduce["tmpcptcode"] = this.scheduleDetails.procedures[
                  index
                ]["cptCode"];
              });
            }
          }

          this.scheduleDetail.insuranceList = [];
          if (
            this.scheduleDetail.payMode === "insurance" &&
            this.scheduleDetails.schedInsurance &&
            this.scheduleDetails.schedInsurance.length > 0
          ) {
            for (
              let index = 0;
              index < this.scheduleDetails.schedInsurance.length;
              index++
            ) {
              this.scheduleDetail.insuranceList.push({
                insId: this.scheduleDetails.schedInsurance[index].insuranceId,
                insType: this.scheduleDetails.schedInsurance[index]
                  .insuranceTypeId,
                insTmpId: this.scheduleDetails.schedInsurance[index]
                  .insuranceId,
                insExists: false,
                insName: this.scheduleDetails.schedInsurance[index]
                  .insuranceName,
                insuranceCustomerCode: this.scheduleDetails.schedInsurance[
                  index
                ].insuranceCustomerCode,
                insuranceCustomerService: this.scheduleDetails.schedInsurance[
                  index
                ].insuranceCustomerService,
                insuranceGroupNumber: this.scheduleDetails.schedInsurance[index]
                  .insuranceGroupNumber,
                insuranceIdNumber: this.scheduleDetails.schedInsurance[index]
                  .insuranceIdNumber,
                insuranceCustomerServiceMask:
                  this.scheduleDetails.schedInsurance[index]
                    .insuranceCustomerCode === "+91"
                    ? environment.indiaPhoneMask
                    : environment.usPhoneMask,
              });
            }
          }

          sessionStorage.setItem(
            "scheduleData",
            JSON.stringify(this.scheduleDetail)
          );
          this.setScheduleDetail();
        }
      });
  }

  getScheduleonDate(datestr) {
    const date = new Date();
    if (datestr) {
      const dateArray = datestr.toString().split("-");
      if (dateArray.length > 1) {
        date.setFullYear(dateArray[0]);
        date.setMonth(dateArray[1] - 1);
        date.setDate(dateArray[2]);
      }
    }
    return date;
  }

  setWaitingListDetails() {
    const waitingListDetail = sessionStorage.getItem("waitinglistdata")
      ? JSON.parse(sessionStorage.getItem("waitinglistdata"))
      : "";
    if (waitingListDetail) {
      this.scheduleDate = this.getScheduleonDate(waitingListDetail.scheduleOn);
      this.homedate = this.datePipe.transform(this.scheduleDate, 'yyyy-MM-dd');
      this.homeInsurance = waitingListDetail.payMode;

      sessionStorage.setItem(
        "waitinglistpatient",
        JSON.stringify(waitingListDetail.patient)
      );

      if (waitingListDetail.payMode === "self") {
        this.homeInsurance = "self";
        this.selfAmount = waitingListDetail.amount;
        this.isSelf = true;
      } else {
        this.selectedIns = waitingListDetail.insuranceList;
      }

      this.selectedcptCodeList = waitingListDetail.cptCodeList;
      setTimeout(() => {
        this.getScheduleList();
      }, 800);
      this.setExamAndBodyPart();
    }
  }

  setExamAndBodyPart() {
    for (let index = 0; index < this.selectedcptCodeList.length; index++) {
      this.onChangedCptcode(this.selectedcptCodeList[index], index, "wait");
    }
  }

  setScheduleDetail() {
    const scheduleDatail = sessionStorage.getItem("scheduleData")
      ? JSON.parse(sessionStorage.getItem("scheduleData"))
      : "";
    if (scheduleDatail) {
      this.scheduleDate = this.getScheduleonDate(scheduleDatail.scheduledOnStr);
      this.homedate = this.datePipe.transform(this.scheduleDate, 'yyyy-MM-dd');
      this.selectedSchedule = scheduleDatail.selectedSchedule;
      this.homeInsurance = scheduleDatail.payMode;
      if (this.scheduleID) {
        scheduleDatail.selectProcedureList = this.selectProcedureList;
      }
      if (scheduleDatail.payMode === "self") {
        this.homeInsurance = "self";
        this.selfAmount = scheduleDatail.amount;
        this.isSelf = true;
      } else {
        this.selectedIns = scheduleDatail.insuranceList;
      }

      if (
        scheduleDatail.selectProcedureList &&
        scheduleDatail.selectProcedureList.length > 0
      ) {
        if (scheduleDatail.selectProcedureList.length > 1) {
          this.multiplePro = true;
        }

        this.selectProcedureList = scheduleDatail.selectProcedureList;
        this.examChecklist();
        this.getScheduleList();
        this.timeSlotChanges();
      }
    }
  }

  getAllinsurancebycountry() {
    const contry: any = {};
    contry.countryId = this.countryId;
    this.appService
      .getallinsurancebycountryByTcId(contry)
      .subscribe((res: any) => {
        if (res.status.status === 200) {
          this.insuranceList = res.entity;
        }
      });
  }

  checkValue(input, type) {
    if (type) {
      if (this.selectProcedureList.length <= 1) {
        this.selectProcedureList = [];
        this.selectProcedureList[0].examId = input.id;
      }
    }
  }

  addOtherInsurance() {}

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign(this.config, { class: "popup-center modal-xl" })
    );
  }

  addProcedure() {
    const p = 0;
    for (let index = 0; index < this.selectProcedureList.length; index++) {
      this.selectProcedureList[index].open = false;
    }
    if (this.selectProcedureList.length >= 1) {
      this.scheduleFormSubmit("");
    } else {
      this.toastr.error("Please check entered cptcode");
    }
  }

  getSelectProcedureSize() {
    if (this.selectProcedureList && this.selectProcedureList.length === 1) {
      return 150;
    } else if (
      this.selectProcedureList &&
      this.selectProcedureList.length === 2
    ) {
      return 230;
    } else {
      return 300;
    }
  }

  onToggleCalendar(event: any): void {
    event.stopPropagation();
    this.mydp.openBtnClicked();
  }

  onToggleCalendar2(event: MyDatePicker, ev: any): void {
    ev.stopPropagation();
    event.openBtnClicked();
  }

  onCalendarToggle(event: number) {}

  withDefaultEvent(event) {
    console.log(event);
    this.showErrDate = false;
    if (event.valueText) {
      const scheduleDate = new Date();
      scheduleDate.setFullYear(+event.inst._wheelArray[2]);
      scheduleDate.setMonth(+event.inst._wheelArray[0]);
      scheduleDate.setDate(+event.inst._wheelArray[1]);

      this.scheduleDate = scheduleDate;
      this.homedate = this.datePipe.transform(scheduleDate, 'yyyy-MM-dd');
      this.timeSlotChanges();

      console.log(scheduleDate);
    }
    this.isDateSelect = true;
    const errorIndex = this.errors.findIndex((error) => error.code === 14);
    if (errorIndex >= 0) {
      this.errors.splice(errorIndex, 1);
    }
  }


  validate(schedDate) {
    if (schedDate != null) {
      const validDate = moment(schedDate, "MMM DD,YYYY").isValid();
      if (validDate) {
        if (moment().diff(schedDate) <= 0) {
          this.showErrDate = false;
        } else {
          this.showErrDate = true;
        }
      } else {
        this.showErrDate = true;
      }
    }
  }

  formatHomeDate(date) {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    let day = date.getDate();
    if (day && day < 10) {
      day = "0" + day;
    }
    const monthIndex = date.getMonth();
    const year = date.getFullYear();

    return monthNames[monthIndex] + " " + day + "," + year;
  }

  addSelectProcedureList() {
    if (this.selectProcedureList.length < 5) {
      this.selectProcedureList.push({
        examId: "",
        bodyPartList: [],
        bodyPartId: "",
        procedureList: [],
        cptCode: "",
        procedureName: "",
        open: false,
        duration: "",
        invalidcptcode: false,
        tmpcptcode: "",
      });
    }
  }

  scheduleFormSubmit(type) {
    let valid = true;
    this.homeinfosubmit = true;
    this.isWaiting = false;

    if (
      this.homeDate &&
      !this.showErrDate &&
      this.homeLocation &&
      this.selectProcedureList &&
      this.selectProcedureList.length > 0
    ) {
      for (let i = 0; i < this.selectProcedureList.length; i++) {
        if (
          this.selectProcedureList[i].examId &&
          this.selectProcedureList[i].bodyPartId &&
          this.selectProcedureList[i].cptCode
        ) {
          // console.log("ifff");
        } else {
          valid = false;
          break;
        }
      }
    } else {
      valid = false;
    }

    if (valid) {
      if (type === "") {
        this.openModal(this.anotherProcedureNew);
        this.selectMultipleProcedure();
      } else if (type === "modal") {
        this.selectMultipleProcedure();
      } else if (type === "close") {
        this.examChecklist();
        for (let index = 0; index < this.selectProcedureList.length; index++) {
          this.selectProcedureList[index].open = false;
        }
        this.modalRef.hide();
      } else if (type === "submit") {
        this.getErrors();
        if (this.errors.length === 0) {
          this.saveSchedule();
        } else {
          this.errorMessage = "Please fill all the fields";
          setTimeout(() => {
            this.errorMessage = "";
          }, 5000);
        }
      } else if (type === "waiting") {
        this.isWaiting = true;
        this.getErrors();
        if (this.errors.length === 0) {
          this.saveSchedule();
        } else {
          this.errorMessage = "Please fill all the fields";
          setTimeout(() => {
            this.errorMessage = "";
          }, 5000);
        }
      }
    } else {
      this.getErrors();
      this.toastr.error("Please fill all the fields.");
    }
  }

  closeModalRef() {
    if (this.popuptype === "self") {
      this.homeInsurance = "insurance";
    }
    this.modalRef.hide();
  }

  yesButtononPopup() {
    if (this.popuptype === "insurance") {
      this.selectedIns.splice(this.index, 1);
      this.modalRef.hide();
    }
  }

  openModal1(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign(this.config, { class: "popup-center" })
    );
  }

  removeInsurance(index) {
    this.popuptype = "insurance";
    this.popupheading = "Remove";
    this.index = index;
    this.popupContent = "Are you sure want to remove?";
    this.openModal1(this.yesornoPopup);
  }

  private validateSelectedInsurance() {
    let missing = false;
    let duplicate = false;
    for (let index = 0; index < this.selectedIns.length; index++) {
      if (this.selectedIns[index].insExists) {
        this.toastr.error(
          "Same insurance not allowed, Please choose different"
        );
        duplicate = true;
        break;
      }

      if (!this.selectedIns[index].insId) {
        this.toastr.error("Please Fill Missing details");
        missing = true;
        break;
      } else if (
        !this.selectedIns[index].insType &&
        this.testCountryCode === "US"
      ) {
        this.toastr.error("Please Fill Missing details");
        missing = true;
        break;
      }
    }
    return { missing, duplicate };
  }

  addInsurance() {
    if (this.selectedIns.length > 0) {
      this.toastr.clear();
      const { missing, duplicate } = this.validateSelectedInsurance();

      if (!missing && !duplicate) {
        this.selectedIns.push({
          insId: "",
          insType: "",
          insTmpId: "",
          insExists: false,
          insName: "",
        });
      }
    }
  }

  insuranceTypeChange(input, index) {
    this.toastr.clear;
    this.isSelf = false;
    let exists = false;
    for (let i = 0; i < this.selectedIns.length; i++) {
      if (this.selectedIns[i].insId === this.selectedIns[index].insTmpId) {
        this.toastr.clear();
        this.toastr.error("Insurance already choosed");
        exists = true;
        this.selectedIns[index].insTmpId = "";
        this.selectedIns[index].insId = "";
        this.selectedIns[index].insExists = true;
        break;
      } else {
        this.selectedIns[index].insExists = false;
      }
    }

    if (!exists) {
      if (!this.selectedIns[index].insType) {
        this.selectedIns[index].insType = "";
      }
      this.insuranceList.forEach((obj) => {
        if (obj.id.toString() === this.selectedIns[index].insTmpId) {
          this.selectedIns[index].insName = obj.name;
        }
      });
      this.selectedIns[index].insId = this.selectedIns[index].insTmpId;
      this.homeInsurance = "insurance";
      if (input.value) {
        const errorIndex = this.errors.findIndex((error) => error.code === 12);
        if (errorIndex >= 0) {
          this.errors.splice(errorIndex, 1);
        }
      } else {
        const errorIndex = this.errors.findIndex((error) => error.code === 12);
        if (errorIndex === -1) {
          this.errors.push({ code: 12, message: "Insurance is Required" });
        }
      }
    }
  }

  cashChange(input) {
    const lastChar = this.selfAmount[this.selfAmount.length - 1];
    if (!Number.isInteger(+lastChar)) {
      this.selfAmount = this.selfAmount.slice(0, this.selfAmount.length - 1);
    }

    const num = +this.selfAmount;
    if (this.selfAmount && Number.isInteger(num)) {
      const errorIndex = this.errors.findIndex((error) => error.code === 10);
      if (errorIndex >= 0) {
        this.errors.splice(errorIndex, 1);
      }
    } else {
      const errorIndex = this.errors.findIndex((error) => error.code === 10);
      if (errorIndex === -1) {
        this.errors.push({ code: 10, message: "Cash Price is Required" });
      }
    }
  }

  getErrors() {
    this.errors = [];
    if (this.isWaiting === false) {
      if (!this.selectedSchedule && this.scheduleList.length > 0) {
        this.errors.push({ code: 11, message: "Schedule time is Required" });
      }
    }

    if (this.isSelf) {
      if (!this.selfAmount) {
        this.errors.push({ code: 10, message: "Cash Price is Required" });
      }
    } else {
      if (
        this.homeInsurance === 0 ||
        !this.homeInsurance ||
        this.homeInsurance === "self"
      ) {
        this.errors.push({ code: 12, message: "Insurance is Required" });
      }
    }
    if (this.selectProcedureList.length === 1) {
      if (!this.selectProcedureList[0].examId) {
        this.errors.push({ code: 13, message: "Exam Name is Required" });
      }
    }

    if (this.isDateSelect === false) {
      this.errors.push({ code: 14, message: "Date is Required" });
    }
  }

  examChecklist() {
    this.allExamList.forEach((exam) => {
      this.selectProcedureList.forEach((procedure) => {
        if (+procedure.examId === exam.id) {
          exam.checked = true;
          procedure.examName = exam.examshortname;
        }
      });
    });
  }

  triggerdatepicker(event: MyDatePicker) {
    event.openBtnClicked();
  }

  selectMultipleProcedure() {
    this.homeinfosubmit = false;
    this.multiplePro = true;
    this.addSelectProcedureList();
  }
  onChangeAddress(address) {
    this.lat = address.geometry.location.lat();
    this.lng = address.geometry.location.lng();
    if (address && address["address_components"]) {
      this.homeLocation = address.adr_address.replace(/<[^>]{0,2000}>/g, "");

      for (
        let index = 0;
        index < address["address_components"].length;
        index++
      ) {
        if (address["address_components"][index]["types"][0] === "country") {
          if (
            address["address_components"][index]["long_name"] === "India" &&
            address["address_components"][index]["short_name"] === "IN"
          ) {
            this.countryCode = "IN";
            this.homeInsurance = "";
            this.homeInsuranceName = "";
            this.homeInsuranceType = "";
            this.homeInsuranceTypeName = "";
            this.homeInsuranceType = 2;
            this.countryId = 101;
            this.placeholerCptCode = "Procedure Name";
          } else {
            this.countryCode = "US";
            this.homeInsurance = "";
            this.homeInsuranceName = "";
            this.homeInsuranceType = "";
            this.homeInsuranceTypeName = "";
            this.countryId = 231;
            this.placeholerCptCode = "CPT Code";
          }
          this.getAllinsurancebycountry();
        }
      }

      this.homeLocation = "";
      address["address_components"].forEach((obj) => {
        obj.types.forEach((childObj) => {
          if (this.countryCode === "IN") {
            if (childObj === "sublocality_level_1") {
              this.homeLocation = obj.long_name;
            }
            if (
              childObj === "administrative_area_level_2" &&
              this.homeLocation
            ) {
              this.homeLocation = this.homeLocation + ", " + obj.long_name;
            }
            if (
              childObj === "administrative_area_level_2" &&
              this.homeLocation === ""
            ) {
              this.homeLocation = obj.long_name;
            }
            if (
              childObj === "administrative_area_level_1" &&
              this.homeLocation
            ) {
              this.homeLocation = this.homeLocation + ", " + obj.short_name;
            }
            if (
              childObj === "administrative_area_level_1" &&
              this.homeLocation === ""
            ) {
              this.homeLocation = obj.short_name;
            }
          } else {
            if (childObj === "locality") {
              this.homeLocation = obj.long_name;
            }
            if (
              childObj === "administrative_area_level_1" &&
              this.homeLocation
            ) {
              this.homeLocation = this.homeLocation + ", " + obj.short_name;
            }
            if (
              childObj === "administrative_area_level_1" &&
              this.homeLocation === ""
            ) {
              this.homeLocation = obj.short_name;
            }
          }
        });
      });
      this.homeLocationPlaceholder = "Location";
    }
  }

  getallbodypartsbyexamid(examid, index, type?: boolean) {
    if (this.homeInsurance && this.homeInsurance === "self") {
      this.homeInsurance = "";
      this.selfAmount = "";
    }
    const data = {
      examId: examid,
    };
    if (type === true) {
      index = 0;
      this.selectProcedureList = [];
      this.addSelectProcedureList();
    } else if (type === false) {
      this.selectProcedureList.splice(index, 1);
    }
    if (this.selectProcedureList.length === 0) {
      this.addDefaultProcedure();
    }
    if (type === true || type === undefined) {
      this.selectProcedureList[index].examId = examid;
      this.appService.getallbodypartsbyexamidWithTcId(data).subscribe(
        (res) => {
          if (res && res["status"] && res["status"]["status"] === 204) {
            this.handleNoProcedureAvailable();
          } else if (res && res["entity"]) {
            this.selectProcedureList[index].bodyPartList = res["entity"];
            if (this.allExamList && this.allExamList.length > 0) {
              for (let i = 0; i < this.allExamList.length; i++) {
                this.allExamList[i].checked = false;
                if (
                  this.allExamList[i].id ===
                  this.selectProcedureList[index].examId
                ) {
                  this.selectProcedureList[index].examName = this.allExamList[
                    i
                  ].examshortname;
                  this.allExamList[i].checked = true;
                  const errorIndex = this.errors.findIndex(
                    (error) => error.code === 13
                  );
                  if (errorIndex >= 0) {
                    this.errors.splice(errorIndex, 1);
                  }
                }
              }
            }

            this.selectProcedureList[index].bodyPartId = "";
            this.selectProcedureList[index].bodyPartName = "";
            this.selectProcedureList[index].cptCode = "";
            this.selectProcedureList[index].procedureName = "";
            this.selectProcedureList[index].procedureList = [];
          }
        },
        (err) => {
          this.appService.sessionOut(err);
        }
      );
    }
  }

  private handleNoProcedureAvailable() {
    this.errorMessage = "Procedure is not available";
    if (this.allExamList && this.allExamList.length > 0) {
      for (let i = 0; i < this.allExamList.length; i++) {
        this.allExamList[i].checked = false;
      }
    }
    setTimeout(() => {
      this.errorMessage = "";
    }, 5000);
  }

  getallbodypartsbyexamonchange(examid, index, type) {
    const data = {
      examId: examid,
    };

    this.appService.getallbodypartsbyexamidWithTcId(data).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] === 204) {
          this.handleNoProcedureAvailable();
        } else if (res && res["entity"]) {
          this.selectProcedureList[index].bodyPartList = res["entity"];
          if (
            this.cptcodeobject &&
            this.selectProcedureList[index].bodyPartList &&
            this.selectProcedureList[index].bodyPartList.length > 0
          ) {
            for (
              let i = 0;
              i < this.selectProcedureList[index].bodyPartList.length;
              i++
            ) {
              if (
                this.selectProcedureList[index].bodyPartList[i].id ===
                this.cptcodeobject["bodyPartId"]
              ) {
                this.selectProcedureList[index].bodyPartId = this.cptcodeobject[
                  "bodyPartId"
                ];
                this.getallproceduresbybodypartbyonchange(
                  this.selectProcedureList[index].bodyPartList[i].id,
                  index,
                  type
                );
              }
            }
          }
        }
      },
      (err) => {
        this.appService.sessionOut(err);
      }
    );
  }

  getallproceduresbybodypartbyonchange(bodypartId, index, type) {
    if (this.homeInsurance && this.homeInsurance === "self" && !type) {
      this.homeInsurance = "";
      this.selfAmount = "";
    }
    const data = {
      bodypartId: bodypartId,
    };
    this.appService.getallproceduresbybodypartByTcId(data).subscribe(
      (res) => {
        if (res && res["entity"]) {
          for (let e = 0; e < res["entity"].length; e++) {
            res["entity"][e].checked = false;
          }

          this.selectProcedureList[index].procedureList = res["entity"];
          if (
            this.selectProcedureList[index].bodyPartList &&
            this.selectProcedureList[index].bodyPartList.length > 0
          ) {
            for (
              let i = 0;
              i < this.selectProcedureList[index].bodyPartList.length;
              i++
            ) {
              if (
                this.selectProcedureList[index].bodyPartList[i].id ===
                bodypartId
              ) {
                this.selectProcedureList[
                  index
                ].bodyPartName = this.selectProcedureList[index].bodyPartList[
                  i
                ].bodyPart;
                if (this.cptcodeobject) {
                  this.selectProcedureList[index].open = false;
                } else {
                  this.selectProcedureList[index].open = false;
                }
                this.openpopuptemplateonchanged(
                  this.selectProcedureList[index].procedureList,
                  this.selectProcedureList[index].cptCode,
                  index
                );
                break;
              }
            }
          }
          this.applyCptCodeProcedureMatch(index);
        }
      },
      (err) => {
        this.appService.sessionOut(err);
      }
    );
  }

  private applyCptCodeProcedureMatch(index) {
    if (
      this.cptcodeobject &&
      this.selectProcedureList[index].procedureList &&
      this.selectProcedureList[index].procedureList.length > 0
    ) {
      for (
        let i = 0;
        i < this.selectProcedureList[index].procedureList.length;
        i++
      ) {
        if (
          this.selectProcedureList[index].procedureList[i].id ===
          this.cptcodeobject["procedureInfo"]["id"]
        ) {
          this.selectProcedureList[
            index
          ].procedureName = this.cptcodeobject["procedureInfo"][
            "procedureName"
          ];
          this.selectProcedureList[index].duration = this.cptcodeobject[
            "procedureInfo"
          ]["duration"];
          this.selectProcedureList[index].open = false;
        }
      }
    }
  }

  getallproceduresbybodypart(bodypartId, index, docID?: string) {
    if (this.homeInsurance && this.homeInsurance === "self") {
      this.homeInsurance = "";
      this.selfAmount = "";
    }
    const data = {
      bodypartId: bodypartId,
    };
    this.appService.getallproceduresbybodypartByTcId(data).subscribe(
      (res) => {
        if (res && res["entity"]) {
          for (let e = 0; e < res["entity"].length; e++) {
            res["entity"][e].checked = false;
          }
          this.selectProcedureList[index].cptCode = "";
          this.selectProcedureList[index].procedureName = "";
          this.selectProcedureList[index].selectedProcedure = "";
          this.selectProcedureList[index].duration = "";

          this.selectProcedureList[index].procedureList = res["entity"];
          if (
            this.selectProcedureList[index].bodyPartList &&
            this.selectProcedureList[index].bodyPartList.length > 0
          ) {
            for (
              let i = 0;
              i < this.selectProcedureList[index].bodyPartList.length;
              i++
            ) {
              if (
                this.selectProcedureList[index].bodyPartList[i].id ===
                bodypartId
              ) {
                this.selectProcedureList[
                  index
                ].bodyPartName = this.selectProcedureList[index].bodyPartList[
                  i
                ].bodyPart;
                if (this.cptcodeobject) {
                  this.selectProcedureList[index].open = false;
                } else {
                  this.selectProcedureList[index].open = true;
                }
                this.openpopuptemplate(
                  this.selectProcedureList[index].procedureList,
                  index
                );
                break;
              }
            }
          }
          this.applyCptCodeProcedureMatch(index);
          if (docID) {
            document.getElementById(docID).click();
          }
        }
      },
      (err) => {
        this.appService.sessionOut(err);
      }
    );
  }

  openpopuptemplateonchanged(procedures, cptcode, ind) {
    if (this.selectProcedureList && this.selectProcedureList.length > 0) {
      for (let s = 0; s < this.selectProcedureList.length; s++) {
        if (s !== ind) {
          this.selectProcedureList[s].open = false;
        }
      }
    }
    this.selectIndex = ind;
    if (procedures && procedures.length > 0) {
      this.selectProcedureList[ind].open = false;
      for (let index = 0; index < procedures.length; index++) {
        if (procedures[index].cptCode === cptcode) {
          procedures[index].checked = true;
        }
      }
      this.popProcedures = procedures;
    } else {
      this.popProcedures = [{ id: "", cptCode: "", procedureName: "" }];
      this.selectProcedureList[ind].open = false;
    }
  }

  openpopuptemplate(procedures, ind) {
    if (this.selectProcedureList && this.selectProcedureList.length > 0) {
      for (let s = 0; s < this.selectProcedureList.length; s++) {
        if (s !== ind) {
          this.selectProcedureList[s].open = false;
        }
      }
    }
    this.selectIndex = ind;
    if (procedures && procedures.length > 0) {
      this.selectProcedureList[ind].open = true;
      this.popProcedures = procedures;
    } else {
      this.popProcedures = [{ id: "", cptCode: "", procedureName: "" }];
      this.selectProcedureList[ind].open = false;
    }
  }

  changeCptCode(value, spInd, ind, procedure) {
    if (this.homeInsurance && this.homeInsurance === "self") {
      this.homeInsurance = "";
      this.selfAmount = "";
    }

    let isExist = false;
    if (this.selectProcedureList && this.selectProcedureList.length > 0) {
      for (let s = 0; s < this.selectProcedureList.length; s++) {
        if (this.selectProcedureList[s].cptCode === procedure.cptCode) {
          isExist = true;
          break;
        }
      }
    }
    if (!isExist) {
      if (spInd === -1) {
        spInd = 0;
      }
      if (this.selectProcedureList.length === 1) {
        spInd = 0;
      }
      for (
        let p = 0;
        p < this.selectProcedureList[spInd].procedureList.length;
        p++
      ) {
        if (ind !== p) {
          this.selectProcedureList[spInd].procedureList[p].checked = false;
        }
      }
      this.selectProcedureList[spInd].procedureList[ind].checked = value;
      this.selectProcedureList[spInd].cptCode = procedure.cptCode;
      this.selectProcedureList[spInd].tmpcptcode = procedure.cptCode;
      this.selectProcedureList[spInd].procedureName = procedure.procedureName;
      this.selectProcedureList[spInd].duration = procedure.duration;
      this.selectProcedureList[spInd].procedureID = procedure.id;
      this.selectProcedureList[spInd].open = false;
    } else {
      this.toastr.error("Procedure already selected");
    }

    if (this.isDateSelect === true) {
      this.timeSlotChanges();
    }
  }

  timeSlotChanges() {
    this.selectedcptCodeList = [];
    for (let i = 0; i < this.selectProcedureList.length; i++) {
      if (
        this.selectProcedureList[i].examId &&
        this.selectProcedureList[i].bodyPartId &&
        this.selectProcedureList[i].cptCode
      ) {
        this.selectedcptCodeList.push(this.selectProcedureList[i].cptCode);
      }
    }
    if (this.selectedcptCodeList.length > 0) {
      this.getScheduleList();
    } else {
      this.errorMessage = "Please fill all the fields";
    }
    setTimeout(() => {
      this.errorMessage = "";
    }, 5000);
  }

  procedureClick(procedure) {
    if (procedure) {
      this.popProcedures = [];
      if (procedure.procedureList.length > 0) {
        procedure.open = !procedure.open;
        if (procedure.open) {
          this.popProcedures = procedure.procedureList;
        }
      }
    }
  }

  removeSelectProcedureList(index) {
    this.homeinfosubmit = false;
    if (index === 0) {
      // this.selectProcedureList = [{
      //   examId: "",
      //   bodyPartList: [],
      //   bodyPartId: "",
      //   procedureList: [],
      //   cptCode: "",
      //   procedureName: ""
      // }]
      // this.selectProcedureList.splice(index, 1)
    } else {
      this.selectProcedureList.splice(index, 1);
    }
    if (this.selectProcedureList && this.selectProcedureList.length === 1) {
      this.modalRef.hide();
      this.multiplePro = false;
    }
    this.timeSlotChanges();
  }

  closeModal() {
    this.scheduleFormSubmit("close");
    if (this.isSelf) {
      this.selectedcptCodeListAmount = [];
      for (let i = 0; i < this.selectProcedureList.length; i++) {
        if (
          this.selectProcedureList[i].examId &&
          this.selectProcedureList[i].bodyPartId &&
          this.selectProcedureList[i].cptCode
        ) {
          this.selectedcptCodeListAmount.push(
            this.selectProcedureList[i].cptCode
          );
        }
      }

      const data = {
        cptcode: this.selectedcptCodeListAmount,
        payMode: "self",
      };
      this.appService.getSelfAmount(data).subscribe((res) => {
        if (res && res["status"] && (res["status"]["status"] === "200" || res["status"]["status"] === 200)) {
          if (res["entity"]) {
            if (this.testCountryCode === "US") {
              this.selfAmount = res["entity"]["amount"];
            }

            if (this.testCountryCode === "IN") {
              this.selfAmount = res["entity"]["amount"];
            }
          }
        }
      });
    }
  }

  cancelModal() {
    let valid = true;
    for (let s = 0; s < this.selectProcedureList.length; s++) {
      if (this.selectProcedureList[s].procedureName === "") {
        this.selectProcedureList.splice(s, 1);
        valid = false;
        break;
      }
    }
    for (let index = 0; index < this.selectProcedureList.length; index++) {
      this.selectProcedureList[index].open = false;
    }
    this.modalRef.hide();
    this.examChecklist();
  }

  resetExam() {
    this.examChecklist();
    this.selectedIns = [
      { insId: "", insType: "", insTmpId: "", insExists: false, insName: "" },
    ];
    this.homeInsurance = "";
    this.selfAmount = "";
  }

  saveSchedule() {
    const date1 = moment(
      this.datePipe.transform(this.homeDate, "yyyy-MM-dd") + " 00:00:00"
    );
    const date2 = moment(
      this.datePipe.transform(this.today, "yyyy-MM-dd") + " 00:00:00"
    );
    const date3 = new Date();
    date3.setMinutes(0);
    date3.setSeconds(0);
    const day = new Date(this.homeDate).getDay();
    const scheduleOn = this.datePipe.transform(this.homeDate, "yyyy-MM-dd");
    this.findDay(day);
    this.findpaymode();
    if (
      this.homeDate &&
      this.homeLocation &&
      this.selectProcedureList &&
      this.selectProcedureList.length > 0
    ) {
      for (let i = 0; i < this.selectProcedureList.length; i++) {
        if (
          this.selectProcedureList[i].examId &&
          this.selectProcedureList[i].bodyPartId &&
          this.selectProcedureList[i].cptCode
        ) {
          this.cptCodeList.push(this.selectProcedureList[i].cptCode);
        }
      }

      const scheduledData: any = {
        scheduleId: this.scheduleID
          ? this.scheduleID
          : this.scheduleappointmentid,
        type: this.scheduleID ? "reschedule" : "",
        scheduleOn: scheduleOn,
        scheduleOnStr: scheduleOn,
        dayOfweek: this.dayOfweek,
        location: this.homeLocation,
        insuranceList: this.selectedIns,
        selectProcedureList: this.selectProcedureList,
        cptCodeList: this.cptCodeList,
        payMode: this.paymode,
        countryCode: this.countryCode,
        latitude: this.lat,
        longitude: this.lng,
        selectedExam: "",
        selectedExamId: "",
        today: date1.toString() === date2.toString() ? true : false,
        timeZone: this.convetTimeZoneOffsetToTime(),
        currentTime: this.datePipe.transform(date3, "hh:mm aa"),
      };

      if (this.paymode === "self") {
        scheduledData.amount = this.selfAmount;
      }
      if (this.selectedSchedule) {
        scheduledData.selectedSchedule = this.selectedSchedule;
        scheduledData.scheduledOnStr = scheduledData.scheduleOn = this.selectedSchedule.date;
        scheduledData.scheduleFromTime = this.scheduleID
          ? this.selectedSchedule.procedureInputs[0].startTime
          : this.selectedSchedule.procedureInputs[0].fromTime;
        scheduledData.scheduleToTime = this.scheduleID
          ? this.selectedSchedule.procedureInputs[0].endTime
          : this.selectedSchedule.procedureInputs[0].toTime;
      }
      if (this.scheduleID) {
        scheduledData.patientDetail = this.scheduleDetail;
      }
      sessionStorage.setItem("scheduleData", JSON.stringify(scheduledData));
      sessionStorage.removeItem("waitinglistdata");
      if (this.isWaiting === false) {
        this.router.navigateByUrl(
          `/` +
            localStorage.getItem("testCode").toString() +
            `/confirming-details`
        );
      } else {
        this.router.navigateByUrl(
          `/` + localStorage.getItem("testCode").toString() + `/waiting-list`
        );
      }
    }
  }

  getRound(value): number {
    if (value) {
      return Math.round(value * 100) / 100;
    }
    return 0;
  }

  getFloor(value): number {
    if (value) {
      return Math.floor(value);
    }
    return 0;
  }
  findDay(day) {
    if (day === 0) {
      this.dayOfweek = "Sunday";
    }
    if (day === 1) {
      this.dayOfweek = "Monday";
    }
    if (day === 2) {
      this.dayOfweek = "Tuesday";
    }
    if (day === 3) {
      this.dayOfweek = "Wednesday";
    }
    if (day === 4) {
      this.dayOfweek = "Thursday";
    }
    if (day === 5) {
      this.dayOfweek = "Friday";
    }
    if (day === 6) {
      this.dayOfweek = "saturday";
    }
  }

  findpaymode() {
    if (this.homeInsurance === "self") {
      this.paymode = "self";
    } else {
      this.paymode = "insurance";
    }
  }

  convetTimeZoneOffsetToTime() {
    this.timezone_offset_min = new Date().getTimezoneOffset();
    this.offset_hrs = Math.abs(this.timezone_offset_min / 60);
    this.offset_min = Math.abs(this.timezone_offset_min % 60);
    let timezone_standard = "";

    if (this.offset_hrs < 10) {
      this.offset_hrs = "0" + Math.floor(this.offset_hrs);
    }

    if (this.offset_min < 10) {
      this.offset_min = "0" + this.offset_min;
    }

    // Add an opposite sign to the offset
    // If offset is 0, it means timezone is UTC
    if (this.timezone_offset_min < 0) {
      timezone_standard =
        "+" + this.offset_hrs.toString() + ":" + this.offset_min.toString();
    } else if (this.timezone_offset_min > 0) {
      timezone_standard =
        "-" + this.offset_hrs.toString() + ":" + this.offset_min.toString();
    } else if (this.timezone_offset_min === 0) {
      timezone_standard = "+00:00";
    }
    return timezone_standard.toString();
  }

  insuranceChange(type, index) {
    if (this.selectedIns.length > 0) {
      this.selectedIns[index].insType = type;
    }
  }

  selfChange(input) {
    this.isSelf = input;
    if (this.isSelf) {
      this.homeInsurance = "self";
      this.selectedIns = [];
      this.selectedIns.push({
        insId: "",
        insType: "",
        insTmpId: "",
        insExists: false,
        insName: "",
      });
      const errorIndex1 = this.errors.findIndex((error) => error.code === 12);
      if (errorIndex1 !== -1) {
        this.errors.splice(errorIndex1, 1);
      }

      this.selectedcptCodeListAmount = [];
      for (let i = 0; i < this.selectProcedureList.length; i++) {
        if (
          this.selectProcedureList[i].examId &&
          this.selectProcedureList[i].bodyPartId &&
          this.selectProcedureList[i].cptCode
        ) {
          this.selectedcptCodeListAmount.push(
            this.selectProcedureList[i].cptCode
          );
        }
      }
      const data = {
        cptcode: this.selectedcptCodeListAmount,
        payMode: "self",
      };
      this.appService.getSelfAmount(data).subscribe((res) => {
        console.log(res["status"]["status"]);
        if (res && res["status"] && (res["status"]["status"] === "200" || res["status"]["status"] === 200)) {
          console.log(res["entity"]);
          if (res["entity"]) {
            console.log(res["entity"]["amount"]);
            
            this.selfAmount = res["entity"]["amount"];
          }
        }
      });
    } else {
      this.selfAmount = "";
      const errorIndex1 = this.errors.findIndex((error) => error.code === 10);
      if (errorIndex1 !== -1) {
        this.errors.splice(errorIndex1, 1);
      }
    }
  }

  gotoPreviousDay() {
    const toDay = new Date();
    const toDayStr = moment(toDay);
    this.scheduleDate.setDate(this.scheduleDate.getDate() - 1);
    this.homedate = this.datePipe.transform(this.scheduleDate, 'yyyy-MM-dd');
    console.log(this.scheduleDate);
    
    const nextDayStr = moment(this.scheduleDate);
    if (nextDayStr.diff(toDayStr, "days") >= 0) {
      this.getScheduleList();
    } else if (nextDayStr.diff(toDayStr, "days") < 0) {
      this.scheduleDate.setDate(this.scheduleDate.getDate() + 1);
    }
  }

  gotoNextDay() {
    this.scheduleDate.setDate(this.scheduleDate.getDate() + 1);
    console.log(this.scheduleDate);
    this.homedate = this.datePipe.transform(this.scheduleDate, 'yyyy-MM-dd');
    this.getScheduleList();
  }

  changeSlot() {
    setTimeout(() => {
      let missing = false;
      let duplicate = false;
      this.toastr.clear();
      if (this.homeInsurance !== "self") {
        ({ missing, duplicate } = this.validateSelectedInsurance());
      } else {
        missing = false;
        duplicate = false;
      }

      if (!missing && !duplicate) {
        this.scheduleFormSubmit("submit");
      }
    }, 270);
  }

  slotChange(timelist, date, index) {
    this.scheduleList.forEach((scheduleData) => {
      if (scheduleData.schedules && scheduleData.schedules.length > 0) {
        scheduleData.schedules.forEach((timeline) => {
          timeline.select = false;
        });
      }
    });
    if (timelist.select) {
      timelist.select = !timelist.select;
      if (timelist.select) {
        timelist.date = date;
        timelist.index = index;
        this.selectedSchedule = timelist;
        const errorIndex = this.errors.findIndex((error) => error.code === 11);
        if (errorIndex >= 0) {
          this.errors.splice(errorIndex, 1);
        }
      } else {
        this.selectedSchedule = "";
      }
    } else {
      timelist.select = true;
      timelist.date = date;
      timelist.index = index;
      this.selectedSchedule = timelist;
      const errorIndex = this.errors.findIndex((error) => error.code === 11);
      if (errorIndex >= 0) {
        this.errors.splice(errorIndex, 1);
      }
    }
  }

  convertTime12to24 = (time12h) => {
    const [time, modifier] = time12h.split(" ");
    let [hours, minutes] = time.split(":");
    const min = minutes;
    minutes = min;
    if (hours === "12") {
      hours = "00";
    }

    if (modifier === "PM") {
      hours = parseInt(hours, 10) + 12;
    }

    return `${hours}:${minutes}`;
  };
}
